interface AgGridConfiguration {
  licenseKey: string;
}
// Do not store in version control.
// Set this locally / change in Azure Devops
export const agGridConfiguration: AgGridConfiguration = {
  licenseKey: process.env.REACT_APP_AG_GRID_LICENSE ?? ""
};
